// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2024-05-05 22:15:43 +0200 (Sun, 05 May 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 142549 $
//  Purpose   : fulltext parts
// =============================================================================
import React from 'react'

import {loadLazy as ll} from 'uix/parts'

export const TreeSearchFulltext = ll(() => import(/* webpackChunkName: 'search' */ './treesearch'))
export const SearchResult = ll(() => import(/* webpackChunkName: 'search' */ './searchres'))
export const IndexDetails = ll(() => import(/* webpackChunkName: 'search' */ './indexdetails'))
export const TreeSearchSemantic = ll(() => import(/* webpackChunkName: 'search' */ './semsearch'))
